import {
  checkWidth,
  checkHeight,
  formatPhoneNumber,
  numbersOnly
} from '../utilities/utility';
import { formPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import * as constantConfig from '../utilities/constant_config';

const $doc = $(document);
const clsHidden = 'hidden';
const smsEnrollmentSection = '.smsEnrollmentPopup';
const smsUnsubscribeModal = '#smsUnsubscribePopup';
const smsUnsubscribeForm = '#smsUnsubscribeForm';
const smsEnrollForm = '#smsEnrollmentForm';
const cboxOverlay = '#cboxOverlay';
const clsEnrolledEdit = '.sms-enroll-edit';
const clsSmsUnsubcribe = '.sms-phone-unsuscribe';
const clsCheckoutNumberFormat = '.checkout-number-format';
const clsTogBtnNotEnrolled = '.togBtn-notenrolled';
const clsTogBtn = '.togBtn';
const clsCheckoutEnrollPhoneNo = '.checkout-enroll-phone-no';
const clsEditPhone = '.edit-phone-no';
const saveSmsEnroll = '#save-sms-enroll';
const removeSmsEnroll = '#remove-sms-enroll';
const cancelSmsRemoveEnroll = '#cancel-sms-remove-enroll';
const cancelSmsEnroll = '#cancel-sms-enroll';
const unsubscribeSmsInput = '.unsubscribeSmsInput';
const $clsEditEnrollSection = $('.edit-enrolled-section');
const $clsRegistrationPageSms = $('#sms-phone-no');
const $clsEnrollStatus = $('.enroll-status');
const $clsCheckoutEnrollStatus = $('.checkout-enroll-status');
const $clsCheckoutEnrollStatusText = $('.checkout-enroll-status-text');
const $clsSmsNo = $('#phone-no-sms-enroll');
const $clsStatusEnrolled = $('.status-enrolled');
const optedOut = 'OPTOUT';
const notEnrolled = 'NOTENROLLED';
const dataEnrollment = 'data-enrollment-status';
const registrationEnrollPhone = '.registration-enroll-phone-no';
const checkoutPage = 'page-multiStepCheckoutSummaryPage';
const registerPage = 'newRegistration_step1';
const smsDelete = '.sms-delete-section';
const $clserrorMsg = $('.error-msg-text');
const checkoutRegistrationPage = 'page-multiStepCheckoutSummaryPage';
let enrollmentStatus = '';
let parentClass;
let registerationPageFlag;
let checkoutRegitrationFlag;
let toggleFlag;
let registrationSmsEnrollFlag = false;
let updatedSmsNo;
let enrolledPhoneNo;
let smsEnrollAjaxRequest = true;
let smsUnsubscribeAjaxRequest = true;

if (location.pathname.indexOf('checkout') == -1 && location.pathname.indexOf('my-account-home') == -1) {
  $('#smsEnrollmentPopup').removeClass('hidden').addClass('enroll-disabled');
    $('.opt-in-out').on('click', function() {
      var isYesSelected = $(this).val();
      if(isYesSelected == 'yes'){
        $('#smsEnrollmentPopup').removeClass('enroll-disabled');
      }
      else {
        $('#smsEnrollmentPopup').addClass('enroll-disabled');
      }
    });
  };


const smsEnrollment = {
  openEnrollmentForm() {
    enrolledPhoneNo = $clsSmsNo.val();
    $clsEditEnrollSection.addClass(clsHidden);
    $(smsEnrollmentSection)
      .removeClass(clsHidden)
      .find($clsSmsNo)
      .focus();
  },

  getEnrollmentStatus() {
    enrollmentStatus = $(clsTogBtn).attr(dataEnrollment);
  },

  closeEnrollmentForm() {
    $clsSmsNo.val(enrolledPhoneNo);
    $clserrorMsg.addClass(clsHidden);
    $clsSmsNo.removeClass('error-msg-textbox');
    if (registerationPageFlag) {
      if (toggleFlag && !registrationSmsEnrollFlag) {
        smsEnrollment.registrationSmsCancel();
      } else {
        updatedSmsNo = $clsSmsNo.val();
        $clsRegistrationPageSms.val(updatedSmsNo);
        $(registrationEnrollPhone).text(updatedSmsNo);
        if (location.pathname.indexOf('checkout') > -1) {
          $(smsEnrollmentSection).addClass(clsHidden);
          $clsEditEnrollSection.removeClass(clsHidden);
        }
      }
    } else {
      if (enrollmentStatus === notEnrolled || enrollmentStatus === optedOut) {
        $(smsEnrollmentSection).addClass(clsHidden);
        $clsEditEnrollSection.addClass(clsHidden);
        $clsEnrollStatus.removeClass(clsHidden);
        $clsCheckoutEnrollStatus.removeClass(clsHidden);
        $(clsTogBtn).prop('checked', false);
      } else {
        $(smsEnrollmentSection).addClass(clsHidden);
        $clsEditEnrollSection.removeClass(clsHidden);
      }
    }
  },
  validateForm() {
    const phoneNo = $clsSmsNo.val();
    const phone = $clsSmsNo[0].validity.patternMismatch;
    if (!phoneNo || phone) {
      $clserrorMsg.removeClass(clsHidden);
    } else {
      $clserrorMsg.addClass(clsHidden);
      smsEnrollment.submitsmsEnrollForm();
    }
  },
  submitsmsEnrollForm() {
    if (registerationPageFlag) {
      registrationSmsEnrollFlag = true;
      updatedSmsNo = $clsSmsNo.val();
      enrolledPhoneNo = updatedSmsNo;
      smsEnrollment.closeEnrollmentForm();
    } else {
      const url = `${ACC.config.encodedContextPath}${API_REFERENCE.reorderReminder.smsEnrollSave}`;
      const formData = $(`${smsEnrollForm}`).serialize();
      if (!smsEnrollAjaxRequest) return false;
      smsEnrollAjaxRequest = false;
      formPost(url, formData)
        .then(response => {
          smsEnrollAjaxRequest = true;
          const currentStatus = JSON.parse(response).smsEnrollmentStatus;
          const {
            key: responseStatus,
            value: status
          } = smsEnrollment.setStatusName(currentStatus);

          updatedSmsNo = $clsSmsNo.val();
          enrolledPhoneNo = updatedSmsNo;
          if (parentClass) {
            $clsCheckoutEnrollStatusText.text(status);
            $(clsTogBtn).attr(dataEnrollment, responseStatus);
            $(clsCheckoutEnrollPhoneNo).text(updatedSmsNo);
            $clsCheckoutEnrollStatus.addClass(clsHidden);
          } else {
            $clsStatusEnrolled.text(status);
            $clsEnrollStatus.addClass(clsHidden);
            $(clsTogBtn).attr(dataEnrollment, responseStatus);
            $(clsEditPhone).text(updatedSmsNo);
          }
          smsEnrollment.getEnrollmentStatus();
          smsEnrollment.closeEnrollmentForm();
        })
        .catch(error => {
          smsEnrollAjaxRequest = true;
        });
    }
  },
  openUnsubscribepopup(savedView) {
    ACC.colorbox.open('', {
      html: $(smsUnsubscribeModal).html(),
      onLoad: $(cboxOverlay).css('position', 'fixed'),
      width: checkWidth(),
      height: checkHeight(),
      overlayClose: false,
      escKey: false,
      className: savedView
        ? 'sms-phone-savedViewUnsuscribe'
        : 'sms-phone-unsuscribe'
    });
  },
  setStatusName(status) {
    let statusName;
    if (status === 'OPTOUT') {
      statusName = constantConfig.SMS_ENROLLMENT_OPTOUT;
    } else if (status === 'NOTENROLLED') {
      statusName = constantConfig.SMS_ENROLLMENT_NOTENROLLED;
    } else if (status === 'PENDING') {
      statusName = constantConfig.SMS_ENROLLMENT_PENDING;
    } else if (status === 'ACTIVE') {
      statusName = constantConfig.SMS_ENROLLMENT_ACTIVE;
    } else {
      statusName = constantConfig.SMS_ENROLLMENT_NORESPONSE;
    }
    return statusName;
  },
  unsubscribeSmsEnroll() {
    const url = `${ACC.config.encodedContextPath}${API_REFERENCE.reorderReminder.smsEnrollUnsubscribe}`;
    $(`${clsSmsUnsubcribe} ${unsubscribeSmsInput}`).val(updatedSmsNo);
    const formData = $(`${clsSmsUnsubcribe} ${smsUnsubscribeForm}`).serialize();
    if (!smsUnsubscribeAjaxRequest) return false;
    smsUnsubscribeAjaxRequest = false;
    formPost(url, formData)
      .then(response => {
        smsUnsubscribeAjaxRequest = true;
        ACC.colorbox.close();
        const updatedStatusName = JSON.parse(response).smsEnrollmentStatus;
        const {
          key: responseStatus,
          value: updatedStatus
        } = smsEnrollment.setStatusName(updatedStatusName);
        const savedUnsubscribeFlag = $(
          `.sms-phone-savedViewUnsuscribe ${removeSmsEnroll}`
        )
          .parents()
          .hasClass('sms-phone-savedViewUnsuscribe');
        if (savedUnsubscribeFlag) {
          location.reload();
        } else {
          if (parentClass) {
            $clsCheckoutEnrollStatusText.text(updatedStatus);
            $clsCheckoutEnrollStatus.removeClass(clsHidden);
          } else {
            $clsStatusEnrolled.text(updatedStatus);
            $clsEnrollStatus.removeClass(clsHidden);
          }
          $(clsTogBtn).attr(dataEnrollment, responseStatus);
          $clsEditEnrollSection.addClass(clsHidden);
          $clsSmsNo.val('');
        }
      })
      .catch(error => {
        smsUnsubscribeAjaxRequest = true;
      });
  },
  registrationSmsCancel() {
    registrationSmsEnrollFlag = false;
    $(smsEnrollmentSection).addClass(clsHidden);
    $clsEditEnrollSection.addClass(clsHidden);
    $(clsTogBtn).prop('checked', false);
    $clsSmsNo.val('');
    $clsRegistrationPageSms.val('');
  },
  openpopup() {
    parentClass = $clsEditEnrollSection.parents().hasClass(checkoutPage);
    registerationPageFlag = $(saveSmsEnroll)
      .parents()
      .hasClass(registerPage);
    checkoutRegitrationFlag = $(saveSmsEnroll)
      .parents()
      .hasClass(checkoutRegistrationPage);

    toggleFlag = $(clsTogBtn).is(':checked');

    smsEnrollment.getEnrollmentStatus();

    if (registerationPageFlag) {
      if (toggleFlag) {
        smsEnrollment.openEnrollmentForm();
      } else {
        smsEnrollment.registrationSmsCancel();
      }
    } else {
      if (toggleFlag) {
        $clsEnrollStatus.addClass(clsHidden);
        $clsCheckoutEnrollStatus.addClass(clsHidden);
        smsEnrollment.openEnrollmentForm();
      } else if (
        enrollmentStatus !== notEnrolled &&
        enrollmentStatus !== optedOut
      ) {
        smsEnrollment.openUnsubscribepopup();
      } else {
        smsEnrollment.closeEnrollmentForm();
      }
    }
  },
  checkEnrolledToggleBtn() {
    if ($(clsTogBtnNotEnrolled).is(':checked')) {
      smsEnrollment.openEnrollmentForm();
    } else {
      smsEnrollment.closeEnrollmentForm();
    }
  },
  closeUnsubscribeSmsEnroll() {
    ACC.colorbox.close();
    $(clsTogBtn).prop('checked', true);
  },
  changePhoneFormat() {
    $('.phone-view-format').each(function() {
      $(this).text(formatPhoneNumber($(this).text()));
    });
  },
  assignInitialValues() {
    parentClass = $clsEditEnrollSection.parents().hasClass(checkoutPage);
    registerationPageFlag = $(saveSmsEnroll)
      .parents()
      .hasClass(registerPage);
    checkoutRegitrationFlag = $(saveSmsEnroll)
      .parents()
      .hasClass(checkoutRegistrationPage);
  },
  backFocusToTooltip(e) {
    if (e.shiftKey && e.keyCode === 9) {
      setTimeout($('.edit-enrolled .back-focus').focus(), 200);
    }
  },
  init() {
    this.changePhoneFormat();
    this.assignInitialValues();
    $doc.on('click', clsEnrolledEdit, this.openEnrollmentForm);
    $doc.on('click', saveSmsEnroll, this.validateForm);
    $doc.on('click', removeSmsEnroll, this.unsubscribeSmsEnroll);
    $doc.on('click', cancelSmsEnroll, this.closeEnrollmentForm);
    $doc.on('click', clsTogBtn, this.openpopup);
    $doc.on('click', smsDelete, this.openUnsubscribepopup);
    $doc.on(
      'click',
      `${clsSmsUnsubcribe} #cboxClose`,
      this.closeUnsubscribeSmsEnroll
    );
    $doc.on('click', cancelSmsRemoveEnroll, this.closeUnsubscribeSmsEnroll);
    $doc.on('keypress', clsCheckoutNumberFormat, function(e) {
      const format = numbersOnly(e);
      if (format) {
        const thisPhone = $(this);
        const curval = $(this).val();
        thisPhone.val(formatPhoneNumber(curval));
      } else {
        return false;
      }
      return null;
    });
    $clsSmsNo.val(function(index, value) {
      return formatPhoneNumber(value.trim());
    });
    $('.change-focus').on('focus', function() {
      $('.sms-focus-action').focus();
    });
    $('.sms-focus-action').on('keyup', this.backFocusToTooltip);
  }
};

export default smsEnrollment;

smsEnrollment.init();
